import { EFileCollection } from '@/modules/productModule/constants/productConstants'
import type { IFile } from '@/types/globalTypes'

const homePagePrefix = 'content-sections'

export const apiPagesCRM = {
	fetchAvailableSubpages: async () => {
		const response = await apiCommon<string[]>(`${homePagePrefix}`, {
			method: 'GET',
		})
		if (!response) return { data: [] }

		return { data: response }
	},

	fetchAvailableCities: async () => {
		const { data } = await apiCommon<string[]>(`${homePagePrefix}/cities`, {
			method: 'GET',
		})
		if (!data) return { data: [] }

		return { data }
	},

	fetchPageSections: async (type: string, page: string, lang?: string) => {
		let url = `${homePagePrefix}/${type}/${page}`

		if (lang) {
			url = `${url}?lang=${lang}`
		}

		const { data } = await apiCommon<IHomePageSection[]>(url, {
			method: 'GET',
		})
		if (!data) return { data: [] }
		const response = data.map((product) => {
			return HomePageSection(product)
		})
		return { data: response }
	},

	createPageSections: async (type: string, page: string, d: any) => {
		const { data } = await apiCommon<IHomePageSection[]>(`${homePagePrefix}/${type}/${page}`, { method: 'POST', body: homePageSectionToJSON(d) })
		if (!data) return { data: [] }
		const response = data.map((product) => {
			return HomePageSection(product)
		})
		return { data: response }
	},

	createCity: async (cityName: string) => {
		const { data } = await apiCommon<IHomePageSection[]>(`${homePagePrefix}`, {
			method: 'POST',
			body: {
				city: cityName,
			},
		})

		if (!data) return { data: [] }

		return { data }
	},

	deleteCity: async (cityName: string) => {
		const { data } = await apiCommon<IHomePageSection[]>(`${homePagePrefix}/${cityName}`, {
			method: 'DELETE',
		})

		if (!data) return { data: [] }

		return { data }
	},

	updatePageSections: async (type: string, page: string, d: any, sectionID: number) => {
		const { data } = await apiCommon<IHomePageSection>(`${homePagePrefix}/${type}/${page}/${sectionID}`, {
			method: 'PUT',
			body: homePageSectionToJSON(d),
		})
		if (!data) return { data: [] }

		return { data: HomePageSection(data) }
	},

	fetchPageSectionByName: async (type: string, page: string, name: string, lang?: string) => {
		let url = `${homePagePrefix}/${type}/${page}/${name}`

		if (lang) {
			url = `${url}?lang=${lang}`
		}

		const { data } = await apiCommon<IHomePageSection>(url, {
			method: 'GET',
		})
		if (!data) return null
		return HomePageSection(data)
	},

	// for files
	uploadContentSectionImage: async (newsID: number, file: File, collection: EFileCollection) => {
		const formData = new FormData()
		formData.append('file', file, file.name)
		formData.append('collection', collection)

		const { data } = await apiCommon<{ data: IFile }>(`files/ContentSection/${newsID}`, {
			method: 'POST',
			body: formData,
		})
		return FileFromJSON(data)
	},

	deleteContentSectionImage: async (fileID: string) => {
		const data = await apiCommon<string>(`files/${fileID}`, {
			method: 'DELETE',
		})
		return data
	},
}
